import { PartnersListItemResponseDto } from '@tiendanube/common';
import { cirrusApi, tableBehavior } from 'App/rtk';
import { GenericParamsType } from 'commons/types';
import { UsersEndpoints, UsersTags } from './types';
import { BASE_USERS_PARTNERS, UNLINK_PARTNERS } from './urls';

export const partnersApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [UsersTags.partnersList],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [UsersEndpoints.getPartnersList]: builder.query<
        PartnersListItemResponseDto[],
        GenericParamsType
      >({
        query: (params) => ({
          method: 'GET',
          url: BASE_USERS_PARTNERS,
          params,
        }),
        ...tableBehavior(UsersEndpoints.getPartnersList),
        providesTags: [UsersTags.partnersList],
      }),
      [UsersEndpoints.unlinkPartner]: builder.mutation<boolean, void>({
        query: () => ({
          method: 'PUT',
          url: UNLINK_PARTNERS,
        }),
        invalidatesTags:  (_, error) => (error ? [] : [UsersTags.partnersList]),
      }),
    }),
  });

export const { useGetPartnersListQuery, useUnlinkPartnerMutation } =
  partnersApi;
